import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDashboardRealtimeRefresh } from '../../hooks/useDashboardRealtimeRefresh';
import { ActivityFeedRow } from './ActivityFeedRow';
import { fetchExternalActivityFeed, type ActivityEvent } from './activityFeedApi';

export function ExternalProfileActivityFeed() {
  const [items, setItems] = useState<ActivityEvent[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setError(null);
    try {
      const data = await fetchExternalActivityFeed(1, 5);
      setItems(data.results.slice(0, 5));
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Could not load external activity');
      setItems([]);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  useDashboardRealtimeRefresh(load);

  return (
    <article className="v1-card v1-dash-activity-feed flex min-h-0 min-w-0 flex-col">
      <div className="v1-card-head v1-card-head-between">
        <h3 className="v1-card-heading v1-card-heading-sm">External Profile Activity</h3>
        <Link to="/activity?feed=external" className="v1-link-btn v1-link-btn-inline">
          View all ›
        </Link>
      </div>

      {items === null ? (
        <ul className="v1-activity-list space-y-3">
          {[1, 2, 3].map((i) => (
            <li key={i} className="h-14 animate-pulse rounded-xl border-0 bg-slate-100" />
          ))}
        </ul>
      ) : error ? (
        <p className="v1-activity-list text-xs text-red-600">{error}</p>
      ) : items.length === 0 ? (
        <div className="v1-activity-list flex flex-1 flex-col justify-center rounded-xl border border-dashed border-slate-200/90 bg-gradient-to-b from-slate-50/90 to-white px-4 py-5">
          <p className="text-sm font-semibold text-slate-800">No external profile views yet</p>
          <p className="mt-2 text-sm leading-relaxed text-slate-600">
            When recruiters or visitors view your public profile, prompt videos, or request access,
            those events appear here.
          </p>
        </div>
      ) : (
        <ul className="v1-activity-list divide-y divide-slate-100">
          {items.map((ev) => (
            <ActivityFeedRow key={ev.id} event={ev} dense />
          ))}
        </ul>
      )}
    </article>
  );
}
